import React from 'react';

const IconChevronUp = (props) => {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
           className={props.addClass}>
         <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
   );
}
export default IconChevronUp;